import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

/**
 * 7-day per-stage count trend (`/api/dashboard/pipeline-trend?days=7`), fetched
 * ONCE by the ERP Layout (useLoadPipelineTrend) and shared through this context
 * with the Dashboard's phone-only Pipeline cards — the header's pipeline rail
 * and the dashboard make one request, not two.
 * Value: `null` until loaded (or on error), else `{ dates, series, count }`.
 */
export const PipelineTrendContext = createContext(null);

export function useLoadPipelineTrend() {
  const [trend, setTrend] = useState(null);
  useEffect(() => {
    let live = true;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/dashboard/pipeline-trend`, { params: { days: 7 } })
      .then(r => { if (live) setTrend(r.data); })
      .catch(() => { if (live) setTrend(null); });
    return () => { live = false; };
  }, []);
  return trend;
}

export function usePipelineTrend() {
  return useContext(PipelineTrendContext);
}
